import { useMutation, useQueryClient } from "@tanstack/react-query"

import type { PublishRewaveBody } from "@/components/sheriff/rewaving/types"
import { supabase } from "@/lib/supabase"
import { getFunctionsBaseUrl } from "@/utils/getFunctionsBaseUrl"

async function publishRewave(body: PublishRewaveBody) {
  const { data: sessionData } = await supabase.auth.getSession()
  const token = sessionData.session?.access_token

  const res = await fetch(`${getFunctionsBaseUrl()}/shifts/rewaves`, {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })

  const json = await res.json()
  if (!res.ok || json?.success === false) {
    throw new Error(json?.error || `Failed to publish waves (status ${res.status})`)
  }

  return json.data as { id: string; shiftsUpdated: number }
}

export const usePublishRewave = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: publishRewave,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["rewavePool"] })
    },
  })
}
